// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__v5zoP","spinner":"Loader_spinner__kxEXc","spinner-d3wgkg":"Loader_spinner-d3wgkg__-KUsY"};